var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 94,
    height: 94,
    rx: 12,
    fill: "#F8F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1812 54.3333C54.7646 54.3333 60.1015 49.11 60.1015 42.6667C60.1015 36.2233 54.7646 31 48.1812 31C41.5978 31 36.2609 36.2233 36.2609 42.6667C36.2609 49.11 41.5978 54.3333 48.1812 54.3333ZM47.1594 58.3333C34.3688 58.3333 24 68.4815 24 81H71C71 68.4815 60.6312 58.3333 47.8406 58.3333H47.5H47.1594Z",
    fill: "#1462D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7391 40.6667C56.7391 46.7418 51.7072 51.6667 45.5 51.6667C39.2928 51.6667 34.2609 46.7418 34.2609 40.6667C34.2609 34.5915 39.2928 29.6667 45.5 29.6667C51.7072 29.6667 56.7391 34.5915 56.7391 40.6667ZM57.4203 40.6667C57.4203 47.11 52.0834 52.3333 45.5 52.3333C38.9166 52.3333 33.5797 47.11 33.5797 40.6667C33.5797 34.2233 38.9166 29 45.5 29C52.0834 29 57.4203 34.2233 57.4203 40.6667ZM22.0098 78.3333C22.0033 78.5548 22 78.777 22 79H22.6812H68.3188H69C69 78.777 68.9967 78.5548 68.9902 78.3333C68.6298 66.1232 58.4033 56.3333 45.8406 56.3333H45.5H45.1594C32.5967 56.3333 22.3702 66.1232 22.0098 78.3333ZM45.8406 57C58.0271 57 67.9486 66.4915 68.3087 78.3333H22.6913C23.0514 66.4915 32.9729 57 45.1594 57H45.5H45.8406Z",
    fill: "#000B32",
    stroke: "#000B32",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 57H65V57.6667H89V57ZM65 62.3333H89V63H65V62.3333ZM69 67.6667H89V68.3333H69V67.6667ZM73 78.3333H89V79H73V78.3333ZM89 73H71.6667V73.6667H89V73Z",
    fill: "#000B32",
    stroke: "#000B32",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0002 44.9708C89.0002 49.3881 85.4193 52.969 81.0021 52.969C76.5848 52.969 73.0039 49.3881 73.0039 44.9708C73.0039 40.5536 76.5848 36.9727 81.0021 36.9727C85.4193 36.9727 89.0002 40.5536 89.0002 44.9708Z",
    fill: "#1462D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4025 50.6946C83.446 50.6946 86.7239 47.4167 86.7239 43.3732C86.7239 39.3297 83.446 36.0518 79.4025 36.0518C75.359 36.0518 72.0811 39.3297 72.0811 43.3732C72.0811 47.4167 75.359 50.6946 79.4025 50.6946ZM79.4025 51.3713C83.8197 51.3713 87.4006 47.7904 87.4006 43.3732C87.4006 38.9559 83.8197 35.375 79.4025 35.375C74.9852 35.375 71.4043 38.9559 71.4043 43.3732C71.4043 47.7904 74.9852 51.3713 79.4025 51.3713Z",
    fill: "#000B32",
    stroke: "#000B32",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1393 40.6576L78.7352 45.9157L75.7305 42.9922L76.6744 42.0221L78.7352 44.0272L83.1954 39.6875L84.1393 40.6576Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.b2895e37.svg";
export { ForwardRef as ReactComponent };